export const toQueryString = (filterObject) => {
  const parts = [];

  for (const key in filterObject) {
    if (
      Object.prototype.hasOwnProperty.call(filterObject, key) &&
      Array.isArray(filterObject[key])
    ) {
      const values = filterObject[key];

      if (values?.length > 0) {
        const valueString = values?.join(',');
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(valueString);
        parts.push(`${encodedKey}=${encodedValue}`);
      }
    } else if (Object.prototype.hasOwnProperty.call(filterObject, key)) {
      parts.push(
        `${encodeURIComponent(key)}=${encodeURIComponent(filterObject[key])}`,
      );
    }
  }

  if (parts.length > 0) {
    return '&' + parts.join('&');
  }

  return '';
};
